<template>
  <b-navbar-nav>
    <b-button-group class="px-1">
      <b-button id="popover-cart" variant="light">
        <i class="fa-solid fa-cart-shopping" style="color: #007bff"></i>
        Cart
        <b-badge>{{ itemCount }}</b-badge>
      </b-button>
      <b-button
        variant="light"
        :disabled="!hasItems"
        v-b-modal="'modal-pay'"
      >
        <i class="fa-solid fa-cash-register" style="color: #007bff"></i>
        Proceed to checkout
      </b-button>
    </b-button-group>
    <b-popover
      class="pop"
      target="popover-cart"
      placement="bottomleft"
      triggers="hover focus"
    >
      <template v-if="hasItems">
        <b-table striped hover :items="orderList" :fields="fields" small>
          <template #cell(price)="data">
            ${{ data.item.price }}
          </template>
        </b-table>
        <b-alert variant="dark" show>
          There {{ verb }} {{ itemCount }} {{ noun }}, the total amount is ${{ amount }}.
        </b-alert>
      </template>
      <b-alert v-else variant="dark" show>
        There is no course in the cart.
      </b-alert>
    </b-popover>
    <b-modal
      id="modal-pay"
      ref="payModal"
      size="lg"
      scrollable
      ok-only
      ok-variant="warning"
      :ok-title="okTitle"
      :title="title"
      header-text-variant="dark"
      header-bg-variant="light"
    >
      <!-- ✅ ここで子からのイベントを受け取る -->
      <PayPalCheckout @payment-complete="handlePaymentComplete" />
    </b-modal>
  </b-navbar-nav>
</template>

<script>
import {mapState, mapGetters, mapMutations} from "vuex";
import PayPalCheckout from "@/components/PayPalCheckout.vue";
export default {
  name: "ShoppingCart",
  components: {
    PayPalCheckout,
  },
  data() {
    return {
      fields: [
        { key: 'courseName', label: process.env.VUE_APP_CART_COURSE },
        { key: 'price', label: process.env.VUE_APP_CART_PRICE },
        // { key: 'language', label: process.env.VUE_APP_CART_LANGUAGE }
      ],
      okTitle: process.env.VUE_APP_PAYPAL_CANCEL,
      cancel: process.env.VUE_APP_PAYPAL_CANCEL,
      title: process.env.VUE_APP_TITLE,
    }
  },
  computed: {
    ...mapState("cart", ["orderList"]),
    ...mapGetters("cart", ["amount"]),
    itemCount() {
      return this.orderList.length;
    },
    verb() {
      return this.itemCount === 1 ? 'is' : 'are';
    },
    noun() {
      return this.itemCount === 1 ? 'course' : 'courses';
    },
    hasItems() {
      return this.orderList.length > 0;
    },
  },
  methods: {
    ...mapMutations('cart', ['clearCart']),
    // ✅ 子からの支払い完了イベントを受けて modal を閉じ、遷移
    handlePaymentComplete() {
      this.okTitle = 'OK';
      setTimeout(() => {
        this.$refs.payModal.hide();
        this.clearCart();
        this.$router.go(0);
      }, 2000);
    },
  },
};
</script>

<style src="@/assets/style/bootstrap.css" scoped>

</style>

